'use client';

import { useTranslations } from 'next-intl';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer, viewportOnce } from '@/lib/animations';

export default function WhatWeDo() {
  const t = useTranslations('WhatWeDo');

  const pillars = [
    {
      id: 'instant_payments',
      titleKey: 'pillar_1_title',
      descKey: 'pillar_1_desc',
      icon: (
        <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
        </svg>
      ),
    },
    {
      id: 'licensed_standards',
      titleKey: 'pillar_2_title',
      descKey: 'pillar_2_desc',
      icon: (
        <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
    },
    {
      id: 'regional_scale',
      titleKey: 'pillar_3_title',
      descKey: 'pillar_3_desc',
      icon: (
        <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
        </svg>
      ),
    },
  ];

  return (
    <section aria-labelledby="what-we-do-heading" className="w-full py-16 sm:py-24 px-6 sm:px-10 lg:px-16">
      <div className="max-w-8xl mx-auto space-y-12">
        
        <motion.div
          className="text-center space-y-3  mx-auto"
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          variants={staggerContainer(0.1)}
        >
          <motion.span variants={fadeInUp} className="text-[10px] sm:text-xs font-bold tracking-widest text-red-500 uppercase block">
            {t('badge')}
          </motion.span>
          <motion.h2 variants={fadeInUp} id="what-we-do-heading" className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-900 tracking-tight leading-tight">
            {t('heading')}
          </motion.h2>
          <motion.p variants={fadeInUp} className="text-xs sm:text-sm text-gray-500 font-normal">
            {t('subheading')}
          </motion.p>
        </motion.div>

        {/* 3 Pillars Grid */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          variants={staggerContainer(0.15)}
        >
          {pillars.map((pillar) => (
            <motion.div
              variants={fadeInUp}
              key={pillar.id}
              className="border border-gray-100 rounded-3xl p-8 shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col space-y-5"
            >
              <div className="w-10 h-10 rounded-2xl flex items-center justify-center shrink-0">
                {pillar.icon}
              </div>

              <div className="space-y-2">
                <h3 className="text-lg font-bold text-gray-900 tracking-tight">
                  {t(pillar.titleKey)}
                </h3>
                <p className="text-xs sm:text-sm text-gray-500 leading-relaxed font-normal">
                  {t(pillar.descKey)}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
}